<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import './base/base.css';
export default {
	name: 'app',
	data() {
		return {};
	},
	methods: {}
};
</script>

<style scoped="scoped">
#app {
	width: 100%;
	height: 100%;
}
body,
html {
	margin: 0;
	padding: 0;
	background: #fff;
}
ul li {
	list-style-type: none;
}
</style>
